export const aCustomCssVarsParam = (booleans?: Record<string, boolean>, numbers?: Record<string, number>) => ({
  styleParams: {
    booleans,
    colors: undefined,
    numbers,
    fonts: undefined,
    strings: undefined,
  },
  isMobile: false,
  isRTL: false,
  tpaData: undefined,
});

export function toDisplayProperty(visibility: boolean, display: string = 'block') {
  return visibility ? display : 'none';
}

export const addUnitsIfNeeded = (styleValue: number) => {
  if (isNaN(Number(styleValue))) {
    return styleValue;
  }

  return `${styleValue}px`;
};
